<template>
	<div class="height">
		<!-- <div class="heng">
          <img :src="require('@/assets/images/heng.jpg')" alt="">
      </div>      -->
		<div class="come">
			欢迎来到第四届中国（新密）耐火原料国际交易洽谈会暨耐火材料产业数字化发展论坛
		</div>
		<div class="navigation">
			<div class="flex">
				<ul class="menu">
					<li :class="comname == 'index' ? 'on' : ''">
						<router-link :to="{ name: 'index' }">首页</router-link>
					</li>
					<li :class="comname == 'enterprise' ? 'on' : ''">
						<router-link
							:to="{ name: 'enterprise', query: { id: 1 } }"
							>线上云展</router-link
						>
					</li>
					<li :class="comname == 'exintroduce' ? 'on' : ''">
						<router-link
							:to="{ name: 'exintroduce', query: { id: 1 } }"
							>大会介绍</router-link
						>
					</li>
					<!-- <li :class="comname=='forum'?'on':''"><router-link :to="{name:'forum'}">联系方式</router-link></li> -->
					<!-- <li :class="comname=='enterprise2'?'on':''"><router-link :to="{name:'enterprise',query:{id:2}}">观展企业</router-link></li> -->
					<li :class="comname == 'dynamic' ? 'on' : ''">
						<router-link :to="{ name: 'dynamic' }"
							>大会动态</router-link
						>
					</li>
					<li :class="comname == 'specimens' ? 'on' : ''">
						<router-link :to="{ name: 'specimens' }"
							>大会集锦</router-link
						>
					</li>
					<!-- <li :class="comname=='associatedMedia'?'on':''"><router-link :to="{name:'associatedMedia'}">合作媒体</router-link></li> -->
					<li :class="comname == 'floorplan' ? 'on' : ''">
						<router-link :to="{ name: 'floorplan' }"
							>展位图</router-link
						>
					</li>
					<li :class="comname == 'mediaFocus' ? 'on' : ''">
						<router-link :to="{ name: 'mediaFocus' }"
							>大会服务</router-link
						>
					</li>
					<!-- <li :class="comname=='information'?'on':''"><router-link :to="{name:'information'}">参展手册</router-link></li> -->
					<!-- <li :class="comname=='ceshi'?'on':''"><router-link :to="{name:'ceshi'}">测试</router-link></li> -->
					<!-- <li :class="comname=='contactus'?'on':''"><router-link :to="{name:'contactus'}">联系我们</router-link></li> -->
				</ul>
				<div
					class="position_relative"
					style="display:flex;height:60px;align-items: center;"
					v-if="comname == 'index'"
				>
					<span>分享到：</span>
					<div class="wx" @click="shareToWx()"></div>
					<div class="qq" @click="shareToQQ()"></div>
					<div class="wb" @click="shareToMicroblog()"></div>
				</div>
				<ul class="onhengbank">
					<li :class="comname == 'index' ? 'on' : ''"></li>
					<li :class="comname == 'enterprise' ? 'on' : ''"></li>

					<li :class="comname == 'exintroduce' ? 'on' : ''"></li>
					<!-- <li :class="comname=='forum'?'on':''"></li> -->
					<li :class="comname == 'dynamic' ? 'on' : ''"></li>
					<li :class="comname == 'specimens' ? 'on' : ''"></li>
					<li :class="comname == 'floorplan' ? 'on' : ''"></li>

					<li :class="comname == 'mediaFocus' ? 'on' : ''"></li>
					<!-- <li :class="comname=='associatedMedia'?'on':''"></li> -->
					<!-- <li :class="comname=='information'?'on':''"></li> -->
				</ul>
			</div>
		</div>
		<el-carousel
			height="600px"
			:interval="5000"
			trigger="click"
			style="margin-top: 60px;"
		>
			<el-carousel-item v-for="(item, index) in list" :key="index">
				<img
					:src="item"
					alt="第四届中国（新密）耐火原料交易洽谈会"
					style="height: 100%;"
				/>
				<!-- <el-image :src="item" :flt="cover"></el-image> -->
			</el-carousel-item>
		</el-carousel>
		<el-dialog
			:visible.sync="dialogVisible"
			:close-on-click-modal="true"
			:show-close="false"
			width="250px"
		>
			<div>
				<img
					src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAADu5JREFUeF7tndt22zoMRJP//+ic5dinkmuJwIYGouxOXwtB4FwAkrGT76+vr5+vN/j386Mp8/v7e3O1V8xPa6XxlPa9/Ht59jCleWidyvibWjTKU1a1keuKAt5aslKkNBeNp5RRYdsgFOED8TbIAh4VXjd2niAHhK16tJvkK+anE4HGU248QShiJ8ZfUcDeYo0FQCfdiXJKv8pnkAdUVzQgnQg0Pq2SR6AnyAoxlWBUJKi60dXyUHxG8SrOZhlNVT/FdGT83QlytWKvJmxVPZRMG0SJ2D2XDZKYjJ+wfVA1NU+QRTCeIB+0v7ZBatPFE8QTBCnHE8QT5EUw3mKtRPFGH8dBzt8Jlk4QKqS9BdBDrmr7QAGl3ZTio1wXfTflZi9ehRHVBOWykh+fQbpJoGBTkGg8rYfiY4MsjFQETPis5LdBAoRtkFiCKowqAo6rO2ZAG8QGeUGATjUbZAUh3ULQfS4Fm3SQSiyth+JDxThaA3035cZnkIbrUEoCFWRF9OQZWg8VqQ1ybAtEuKxs4bzFeiBMjUCIucVW8leeoXVtxdP3zoqna7VBKGKJraOqw1MRVU11AII/j9JaZ8XTtdogFDEbZBOxWYKvCJhQXsnvLZa3WC8as0EWSGwQG8QG2floze82d++3mlTGUee4U50FVFeVZK3V8wTt5LQmFRa0TlU8XW9F0/+cQbqvYbvzV8zWXZNK8BUBE5NU8tsgAcJ0cnWL0QYhlniOtUES2HULuDu/DZIgeSfEBklg1y3g7vw2SIJkG6QOUreAu/PbIHXuPUES2HULuDu/DZIgeeYEqZeXe1J1I5J72xJV6S5b71DlueWmFwT02laFEc1DOab5afyoqeFbLPpyGk/Box17rx6VsFV5bBCqnHq8DZLATiVsVR4bJEGaKMQGSQCpErYqjw2SIE0UYoMkgFQJW5XHBkmQJgqxQRJAqoStymODJEgThZQMInq3LA0V3rvHjwyiusi4GkYysQgTvf3fB/lksVxNwN31CHUtS2WDPKDsJp/m9wSRafxQIhvEBnkR0KypfEjJTQ/bIDaIDTIwlw1ig9ggI4P8qD7w0zTiorSqj5pE77nS/9PzzKz4K2FWreXbBqlCN++5WYKnZ5N5COnebIPosDwtkw1yGtRfNsh5WMveZIPIoAwT2SAhRNcLsEHO48QGOQ9r2ZtsEBmUYaJ2g3TfMlGxhIj8FdCdn9YziqcXkpQbigWN31sbXddensolgw0SKFRFstIIKiHZIHckRwa0QWyQtHdps6DxKuN7gqwQUJFAyaHdN63CA4F0K0LXQLGm8ZQDCpW3WCvEKPmUHFV+SrLPIHXEbBAbBKmHmpxOBBpPmxRabPXP4O39+QNarAps5f5xK1eli1AiZsXTtXXHUxy666H5b/XjT/PO6gqVxdkg41saiimNt0EObGlUB8pZeSj5Z8RTAXfH0zV310Pze4IkbsMoyTPjqQC64ykW3fXQ/DaIDbKpYbqNplNcdc6kgqfxNogNYoNEP0lX3WJ1dwXVrRrtjnSbQOOHH3MY/PXVrfeoOjnlkq5ZFU/XO3WCUFBVQqV5aLyKTGrw3/Fugwzht0ES6qSCp/GJEg6FeILU4bNBEthRwdP4RAmHQmyQOnw2SAI7KnganyjhUIgNUofPBklgRwVP4xMlHAqxQerwTTUIFdIZxdahjJ+kB+LKoTuu4lgEXcO7cDxzXfhvFFauyrZoV+U5JqnlaUqCDRIjr+KYcqM0vg3y4JmSYIPYIJsIdHcFulWLacpF2CDxNKXcdGuFNqlKPZ4gniAvOqsIqXMbTZuXt1i5oYCiKAm0e6FiisF0DUohfaxBVL+8mnYdSibVTDf5e/VQHEbrohjRLZBqDXTNNF5VJ9XQLV72a3/ooin5dHE2CEWsfgZRcU8NTt9bQcQGeaBGyTmjq9EmMmsNVKg0/gysd9/hLdYdmlni8hZrQYByoDLakAMbxAb5WyBUeN3xniCVzWHwjM8gdVC7BU/zTzXI3jcKVeOO0kTfS/NTcrrPATT/aL0UOxUWqmakwkJVz+8tlg0y3mJR0lQipcavnKNskHh7bYMEt1g2yPzrX9osPEEoYqt4VdfcK8ETRG8oSrcNQhGzQTYRUzULlSDptKZNiq7XZ5AVwpRkSg69ian0ANX0olh0x1MsVPWcYhAVaVSQ3d2ICp6Spjx0U+zo2mYJ+AyO2w/pNkj9lmwWdjbI6hzVfc07i+QzusuWkOg+d1TnLOxsEBskvStQidRbrAVyigWNT5P7CBxx7C1WgKYNEl/bqgSpnL6kJhuEoPVXrA1ig/wc0M+fR1VjsDsP3V9Tg1AsK2clWhN9B82vWrPqvcpJhP9GIb0yVJGjymODxHJWCXUW1jZIzDH+AhQFNVFCKoQa/5aUCpi+g+ZPLXQV1I01zT/CxxPkQRwFlYqCdtNRfipgG+SOZmX7boPYIC9epAakzaK7GdH8niAJBimoiZSpENrdvcWKYaVcDg3yLt9JV3U1KsjKWN6isJKHrlkpDNUaYjnXIyqYknXdYt/m1/5Qsaj2/N0knPFRk5lrqMs/frJ7XTZIzEHpYEe6lA2SIGEnxAZZAeMJEgvJW6w7RqpttCdIrDlPkESTooJMwJ4K8QRJkJNCchVEyewmwVssyuAS382NJ0iCm24SbJAECZ9wBqG3RqozRR3e3JOz9vW56p6j6HSsvEPxzCzuK/jIrnltEP0BkYqxIgD6DkW8DZLY888CiRLsCUIRi+NncV9pIJ4gAZ82SCx4GmGDeIKkNaMUS6VDpgsVBirXTMqq4OMJ4glCNCaJfSuD7P3aH4oEvQ6l8Verh5Jc6V7d71Dlp3nohY6Ke5rnFj/t+yA2SEwXFR41oSo/zWODHDiDUJL3wKYGVMUryafCo9ip8tM8Soy2cqnq8QRZoWuDxBON3ujFGZ8jqMFpc6T12CA2CNKMDYLgeg5WdeDuLkJJpvHK7QPdKlDsVPlpHiVG7Vus7q/cqsagivxZgqcNZNSrqCApdt2cUSzoepUGlP0chJJAF63Kb4PUtwkqzmyQBAcqsGm3s0ES5OyEqDizQRIcqMC2QWKw6fSlmNItjQ0Sczbt12d6giTI8QT5g4DPIA8orjbRfEhfEKDc0Ik2wnrXILTT0jFOx6xq7Nf753WepNwoBdOJwhU1YYN0Mt6U2wYZA6uaOLe32CBNIu5Ma4PYIGl9KbtF+qWTA20QGyQtQRukfpil58Y0KcVAn0FWwF0RjCKvpz/mCXLiBKHfKJzVsbtFMWtdwyvG79v32V7/qWpVYUo7BJ1cdL3K/PgbhbRYCh69kqT1zBJFBYfuWrvzUy734lUcV/LbIA/UKAkVwdNnugXcnd8GoYwfiFeRqcpzYCnpR7tr7c5vg6SpPh6oIlOV5/iK4gzdtXbnt0FijmURKjJVeWQLGyTqrrU7/0cYhH6jkN4Q0IMRzU/PDjT/1eq/1aNaA13bGU1h6x3UyBSfkYbwp3npyykJNL8NopctxVRfwXNGG2SFhw0Sy41iFGd8jrBBFjw8Qah6HvEzPwlgg9xJOIMDG8QGeUHAE8QTpGiL5bEzupfqFogu1ga5sEGoKKhQaTy9ZFDVP7qtomtQxSvXpritosan9f9ycLVrXroIFfl0X0+7LL2JsUHiaW2DJG63bJDVdgB++rdi2s7Or6qHGmfUHD1BHmh6gtQ7tkrYqjw2yAoBTxBPEGqIv+M9QQ4Yyof0WH6qzq/KE1f8HDE0CP1GIRUM3brQxdH47olDD++0/srhvfvio7IGxTMqrG2QAxNEZSiFIP7Poeq0NM+7NDuKtQ1ig2xqxga5w2KD2CA2yGCs2CA2iA1ig+R2nqozBd2e5KrLRaneTfP8k2cQ+lGTHIXnRV2NZJUBo73xFsKqWx3KHuWgOz81svQbhXRx3fGUHAoerd8GWRBTGbabYxtkpXIbhFo+jqcCjjM+R9D8lGMbxAahmkTxVMAo+eAalk7rvffaIDYI1SSKt0EQXOcGU3Lo+KWroV1t2L12Pr5e6YR0HSSeckByjy4rKNYV3PDv5qWLU8VTMFTxe/V3G+32XnrI7a5JhSk1FF2Xqs5fc6o+rKgyAnW5CuyridEGWZRggyTcpeoK1FCeIAsCsziwQWyQTQSuNtVskIRQZ4XMIscTxBPkZ5boyXttkBgtuhWJMz5HzOKArktV5/CQTsc7BZt2ZuWit95NSaCXCSp8lHm6z2MqDVFuVO+1QVZqoyTYIPEtk0qolBvVe20QG6T1ckAlVBskIVRvsZSbq3sub7FiTHd/UKhyf1zCcwQljcbTsw+tfxZutE4bJIeYDfLAiY5xn0F8BtnUQLeQ6ERQxef6yRKlmhQqPEf1q2rtnr6UA9qkqFZKh3QVoaozBV10d/2UZFU9NkjcvKhWbBCq5lW8qivbIAdI2HlU1XxtkAPc2CDxGeQAvIcetUFW8NGxqerYNogN4kP6oI/ZIDbIWxiE3qyohE3fS29cfve/oq/c0jyVWreeUb2X1qPcVeCfg6gWrdwnEnJskPr2nmKn0ooNcuBMQTs5JZnKiYpiVI8qF81DBUk5oJjSejxBEghTkBIpUyFUjDZICtbNINUuZMSZt1h1fiRnNBukToANssKObo08QfS3TCoO6pZ4ftIGaTBINznK/TgVJH33GQIjeKvqIe+MYv+5LVYESPb/qXjp2eRWB32HDZJlLx9ng+Sxeoqk4rVBYqA9QRJbJtXZoSLImMIlwgY574yj0gTh9/9YT5AKaoXtT8Ww1ITeYhXJHDxmgxQxpeK1QWKgP2KLFS/zWMTMcbpVORU2Nc4xtJ6fptjRtalqpUag71VygCcILZbGU5JpfhpPRaQkR1VrtyBpnd31KDmwQQJ2bRAq/zjeBokx2o3wBKmDR7Gj5q9X9vykDXIASUrygVelHqUiUo73VIGrIIodXRutZy/eBjmAJCX5wKtSj1IR2SAxrB9hkHiZ50Z0C09lBGpw+t4R6hSjWbVSg9B45eR6+79RqLIpFSoljcZX1mWDjFGrcGCDPDC1QRZxVYREDE3z03hPEMJGMtYGsUG2pOIJ4gnyogtVx1Z1clU9lTw2iA1igwx+vZINYoPYIAOD/Aeqt0HUNwmNXwAAAABJRU5ErkJggg=="
					alt="第四届中国（新密）耐火原料交易洽谈会"
					style="width:200px;height:200px;"
				/>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "topmenu",
	data() {
		return {
			dialogVisible: false,
			list: [require("@/assets/images/xmbanner0614.jpg")],
			list1: "",
			isshowlist: true,
			loading: true,
			currentPage: 1, //当前页
			pagesize: 6, //每页显示条数
			totalPage: 0, //总页数
		}
	},
	created() {
		this.getinformation()
	},
	props: ["comname"],
	methods: {
		shareToWx() {
			this.dialogVisible = true
		},
		shareToQQ() {
			//此处分享链接内无法携带图片
			const share = {
				title:
					"第四届中国（新密）耐火原料国际交易洽谈会暨耐火材料产业数字化发展论坛",
				// desc: "描述",
				share_url: "http://xmcimfce.fm086.com/",
			}
			window.open(
				"https://connect.qq.com/widget/shareqq/index.html?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" +
					share.title +
					"&desc=" +
					share.desc
			)
		},
		//分享到微博(可用)
		shareToMicroblog() {
			//自定义内容
			const share = {
				title:
					"第四届中国（新密）耐火原料国际交易洽谈会暨耐火材料产业数字化发展论坛",
				image_url: "",
				share_url: "http://xmcimfce.fm086.com/",
			}
			//跳转地址
			window.open(
				"https://service.weibo.com/share/share.php?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" +
					share.title +
					"&pic=" +
					share.image_url +
					"&searchPic=true"
			)
		},
		clickEffect(event) {
			console.log(event.target.style)
			event.target.style.borderBottom = "10px sold #fff"
		},

		getinformation() {
			let data = {
				current: this.currentPage,
				size: this.pagesize,
				isPage: true,
				iType: 1,
			}
			this.$axios
				.post(
					"/api/app/exhibitionMaterials/getExhibitionMaterialsPageList",
					data
				)
				.then((res) => {
					this.loading = false
					this.totalPage = res[1].pages
					if (res[0].length > 0) {
						let infordata = res[0]
						console.log(infordata[0], "参展手册")
						this.list1 = infordata[0]
						this.isshowlist = true
					} else {
						this.isshowlist = false
					}
				})
		},

		downloadFile(fileName, data) {
			if (!data) {
				return
			}
			let url = window.URL.createObjectURL(new Blob([data]))
			let link = document.createElement("a")
			link.style.display = "none"
			link.href = url
			link.setAttribute("download", fileName)
			document.body.appendChild(link)
			link.click()
		},
	},
}
</script>

<style scoped>
.el-carousel__item {
	display: flex;
	justify-content: center;
}
.height {
	height: 694px;
	position: relative;
	min-width: 1370px;
	width: 100%;
}
.height .el-image__inner {
	width: auto;
	height: 100%;
}
.heng img {
	width: 100%;
}
.navigation {
	background: rgba(0, 0, 0, 0);
	position: absolute;
	z-index: 10;
	width: 100%;
	left: 0;
	right: 0;
	display: flex;
	/* justify-content: space-between; */
	justify-content: flex-start;
}
.navigation .menu {
	/* justify-content: center; */
	/* font-weight: bold; */
	/* background: url('../../assets/images/tab-bg.jpg'); */
	background: #182fb3;
	position: relative;
}
.wdleft {
	width: 505px;
}
.flex {
	flex: 1;
}
.menu {
	flex-shrink: 0;
	display: flex;
	justify-content: center;
	font-family: "微软雅黑";
	font-size: 16px;
}

.menu li {
	padding: 0 1.5% 0;
	height: 60px;
	line-height: 60px;
	width: 80px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: normal;
	position: relative;
	display: inline-block;
	opacity: 0.9;
	font-weight: bold;
}
.menu li a {
	color: #fff;
	font-size: 16px;
}
.menu .on {
	color: #fff;
	opacity: 1;
	font-size: 16px;
	position: relative;
}

/* .menu li:after {
  content: '';
  position: absolute;
  left: auto;
  top: 32%;
  right: 0;
  height: 35%;
  width: 1px;
  background-color: #e6e6e6;
} */
.menu li:last-child::after {
	display: none;
}
.onhengbank {
	/* background: #f5f5f5; */
	width: 100%;
	height: 0px;
	background: rgba(200, 200, 200, 0.3);
	display: flex;
	justify-content: center;
	/* margin-left: 4%; */
}
.onhengbank li {
	height: 2px;
	width: 80px;
	padding: 0 1.5% 0;
	position: relative;
}

.onhengbank li.on::after {
	position: absolute;
	content: "";
	left: 25%;
	top: -1px;
	width: 52%;
	height: 2px;
	background-color: #fff;
}
/* .onhengbank li.on:first-child::after{
  width: 30%;
  left: 35%;
}
.onhengbank li.on:nth-child(7)::after{
  width: 39%;
  left: 32%;
} */

.ml25 {
	margin: 25px 10px 0 2%;
	display: inline-block;
}

/* 控制分享的位置 */
.bshare-custom a {
	display: inline-block;
	border-radius: 10px;
	margin-top: 15px;
	margin-left: 10px;
}
/* 2021 09 08 */
.position_relative {
	position: absolute;
	top: -2px;
	right: 10px;
	color: #fff;
	text-align: center;
}
.position_relative span {
	opacity: 0.9;
}
.wx {
	background: url(../../assets/images/zhanhui_wx.png) no-repeat !important;
	height: 30px;
	width: 30px;
	margin-right: 10px;
}
.qq {
	background: url(../../assets/images/zhanhui_qq.png) no-repeat !important;
	height: 30px;
	width: 30px;
	margin-right: 10px;
}
.wb {
	background: url(../../assets/images/zhanhui_wb.png) no-repeat !important;
	height: 30px;
	width: 30px;
}
.come {
	height: 34px;
	padding-left: 10%;
	line-height: 34px;
	text-align: start;
	font-size: 12px;
	color: #666;
	position: relative;
	z-index: 11;
}
.menu:before {
	content: "CIMFCE";
	font-size: 36px;
	position: absolute;
	top: 6px;
	left: 10%;
	color: #fff;
	font-weight: 700;
	z-index: 12;
}
::v-deep .el-dialog__header {
	display: none !important;
}
</style>
